export const WITHDRAWAL_SUCCESS_MESSAGE_ID = "withdrawal-request-success";
export const WITHDRAWAL_FAILLURE_MESSAGE_ID = "withdrawal-request-faillure";
export const WITHDRAWAL_FORM_ID = "withdrawalForm";
